import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth0 } from "@auth0/auth0-react";
import Api from "../../lib/api";

export const useGetEmployeeAttendance = (key: string, params: any) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    [key, params],
    async ({ queryKey }: any) => {
      const token = await getAccessTokenSilently();
      return await Api.get(`v1/timecards?${params}`, token);
    },
    {
      refetchOnWindowFocus: false,
      retry: 2,
    }
  );
};

export const useDeleteEmployeeAttendance = (key: any) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (projectId: string) => {
      const token = await getAccessTokenSilently();
      return await Api.delete(`v1/timecards/${projectId}`, token);
    },
    {
      onSuccess: () => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({
            queryKey: ["employee-attendance-reports"],
          }),
        ]);
      },
    }
  );

  return mutation;
};

export const useUpdateEmployeeAttendance = (key: any) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data: any) => {
      const token = await getAccessTokenSilently();
      return await Api.post(
        `v1/timecards/update-timecard/${data.projectId}`,
        data.payload,
        token
      );
    },
    {
      onSuccess: () => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({
            queryKey: ["employee-attendance-reports"],
          }),
        ]);
      },
    }
  );

  return mutation;
};
